import React from 'react';
import { useParams } from 'react-router-dom';
import { useGameType } from '../contexts/GameTypeContext';
import { useIsAdmin } from '../hooks/useIsAdmin';
import GameTypeRoutePage from './GameTypeRoutePage';

export default function HomePage({ onLoginClick }) {
  const { gameType } = useGameType();
  const { partnerId } = useParams();
  const { isAdmin } = useIsAdmin();

  return (
    <GameTypeRoutePage
      gameType={gameType}
      onLoginClick={onLoginClick}
      partnerId={partnerId}
      isAdmin={isAdmin}
    />
  );
}
